
import { lazy } from 'react';
import { RouteConfig } from './types';

const ProfilePage = lazy(() => import('../pages/profile/ProfilePage'));
const MyActivityPage = lazy(() => import('../pages/my/MyActivityPage'));

export const profileRoutes: RouteConfig[] = [
  {
    path: '/app/profile',
    element: ProfilePage,
    requiresLayout: true,
  },
  {
    path: '/app/my/activity',
    element: MyActivityPage,
    requiresLayout: true,
    requiredPermissions: ['my_activity.read'],
  },
  {
    path: '/app/my/activity/:userId',
    element: MyActivityPage,
    requiresLayout: true,
    requiredPermissions: ['my_activity.read'],
  },
];
